import { filterConstants } from '../constants'

const initState = {
  filtersState: {
    stores: [],
    journeys: [],
    purchaseDate: null,
    compromiseDate: null,
    textSearch: '',
  },
  filtersResend: {
    enterprises: [],
    stores: [],
    endDate: null,
    textSearch: '',
  },
  filtersHistory: {
    enterprises: [],
    stores: [],
    startDate: null,
    endDate: null
  },
  filtersReassign: {
    stores: [],
    journeys: [],
    purchaseDate: null,
    compromiseDate: null,
    textSearch: '',
  },
};

const filtersStateINIT = {
  stores: [],
  journeys: [],
  purchaseDate: null,
  compromiseDate: null,
  textSearch: '',
}

const filtersResendINIT = {
  enterprises: [],
  stores: [],
  endDate: null,
  textSearch: '',
}

const filtersHistoryINIT = {
  enterprises: [],
  stores: [],
  startDate: null,
  endDate: null
}

const filtersReassignINIT = {
  stores: [],
  journeys: [],
  purchaseDate: null,
  compromiseDate: null,
  textSearch: '',
}

const filterReducer = (state = initState, action) => {

  switch (action.type) {
    case filterConstants.CLEANALL:
      return initState
    case filterConstants.CLEANHISTORY:
      return {
        ...state,
        filtersHistory: filtersHistoryINIT
      }
    case filterConstants.CLEANRESEND:
      return {
        ...state,
        filtersResend: filtersResendINIT
      }
    case filterConstants.CLEANSTATES:
      return {
        ...state,
        filtersState: filtersStateINIT
      }
    case filterConstants.CLEANREASSIGN:
      return {
        ...state,
        filtersReassign: filtersReassignINIT
      }
    case filterConstants.SETHISTORY:
      return {
        ...state,
        filtersHistory: action.filtersHistory
      }
    case filterConstants.SETRESEND:
      return {
        ...state,
        filtersResend: action.filtersResend
      }
    case filterConstants.SETSTATES:
      return {
        ...state,
        filtersState: action.filtersState
      }
    case filterConstants.SETREASSIGN:
      return {
        ...state,
        filtersReassign: action.filtersReassign
      }
    default:
      return state
  }

}

export default filterReducer
